import { ApplicationFormValues } from '../../../../../LoanDetailTypes';
import { Ruleset } from '../../../interfaces/Ruleset';
import { RulesetResult, IsBorrowerTypePropertyCompany } from '../../rules';

class PropertyOwnershipStatusRuleset implements Ruleset {
  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    if (IsBorrowerTypePropertyCompany.evaluate(data)) {
      return RulesetResult.HIDDEN;
    }
    return RulesetResult.REQUIRED;
  };
}

export default new PropertyOwnershipStatusRuleset();
